// extracted by mini-css-extract-plugin
module.exports = {"vendorSearch":"components_vendorSearch__227aX","vendorButton":"components_vendorButton__2xu4I"};